import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  CallProviderAccountRequest,
  CallProviderAccountResponse,
  CallProviderVerifyResponse
} from '../models/call-provider-account.model';

@Injectable({ providedIn: 'root' })
export class CallProviderApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/calls/provider/account`;

  getAccount(): Observable<CallProviderAccountResponse> {
    return this.http.get<CallProviderAccountResponse>(this.base);
  }

  upsertAccount(req: CallProviderAccountRequest): Observable<CallProviderAccountResponse> {
    return this.http.put<CallProviderAccountResponse>(this.base, req);
  }

  deleteAccount(): Observable<void> {
    return this.http.delete<void>(this.base);
  }

  verifyAccount(): Observable<CallProviderVerifyResponse> {
    return this.http.post<CallProviderVerifyResponse>(`${this.base}/verify`, {});
  }
}
